/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsBlog = {
  init: function($section){

    // Add settings from schema to current object
    window.PXUTheme.jsBlog = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.enable_filter == true) {
      $('#blog_filter').on('change', function() {
        window.PXUTheme.jsBlog.blogFilter();
      });
    }

  },
  blogFilter: function() {
  let url = $('#blog_filter').val();
  let $section = $('#blog_filter').closest('.jsBlog');
  let sectionId = $section.find('[data-section-id]').data('section-id');
  let scrollPosition = $(window).scrollTop();
  
  // Add loading state
  $section.css('opacity', '0.5').css('pointer-events', 'none');
  
  // Use Shopify's Section Rendering API to get just this section's content
  let sectionUrl = url + '?section_id=' + sectionId;
  
  $.ajax({
    url: sectionUrl,
    type: 'GET',
    dataType: 'html',
    success: function(data) {
      // Parse the returned section HTML
      let $newSection = $(data);
      
      // Find the blog posts container in the new content
      let $newBlogPosts = $newSection.find('.container[data-load-more--grid]');
      if ($newBlogPosts.length === 0) {
        // Fallback if data-load-more--grid doesn't exist
        $newBlogPosts = $newSection.find('.featured-article').parent();
      }
      
      // Find the current blog posts container
      let $currentBlogPosts = $section.find('.container[data-load-more--grid]');
      if ($currentBlogPosts.length === 0) {
        // Fallback if data-load-more--grid doesn't exist
        $currentBlogPosts = $section.find('.featured-article').parent();
      }
      
      // Replace the blog posts
      if ($newBlogPosts.length && $currentBlogPosts.length) {
        $currentBlogPosts.html($newBlogPosts.html());
      }
      
      // Restore opacity and enable interactions
      $section.css('opacity', '1').css('pointer-events', 'auto');
      
      // Maintain scroll position
      $(window).scrollTop(scrollPosition);
    },
    error: function() {
      // Restore state and fallback to regular page load if AJAX fails
      $section.css('opacity', '1').css('pointer-events', 'auto');
      window.location = url;
    }
  });
},

  unload: function($section) {
    $('#blog_filter').off();
  }
}

/******/ })()
;